import { j as e } from "./atoms-v218.js";
import { Toggle as o, Label as h, LabelText as r, Switch as x, Handle as u } from "./atoms-v2749.js";
import { SkeletonRow as s } from "./atoms-v2778.js";
const $ = ({
  ariaLabel: n,
  className: a,
  defaultChecked: d = !1,
  display: l = "inline",
  labelPosition: i = "left",
  size: t = "default"
}) => /* @__PURE__ */ e.jsx(o, { $display: l, "aria-hidden": "true", "aria-label": n, className: a, children: /* @__PURE__ */ e.jsxs(h, { $isDisabled: !0, $isSkeleton: !0, $display: l, children: [
  i === "left" ? /* @__PURE__ */ e.jsx(r, { children: /* @__PURE__ */ e.jsx(s, { height: t === "default" ? "14px" : "12px" }) }) : null,
  /* @__PURE__ */ e.jsx(x, { $isSkeleton: !0, "aria-hidden": !0, $size: t, children: /* @__PURE__ */ e.jsx(u, { $isSkeleton: !0, $isChecked: d, $size: t, "data-testid": "toggle-handle" }) }),
  i === "right" ? /* @__PURE__ */ e.jsx(r, { $isRightPosition: !0, children: /* @__PURE__ */ e.jsx(s, { height: t === "default" ? "14px" : "12px" }) }) : null
] }) });
export {
  $ as ToggleSkeleton
};
